import { roleAdmin, roleManager, roleSuperAdmin } from '@/mixins/roles';

const WorldToursPriceTypes = () => import('@/pages/world-tours/priceTypes.vue');

export default [
  {
    path: '/world-tours/price-types',
    name: 'WorldToursPriceTypes',
    meta: {
      auth: {
        roles: [roleAdmin, roleSuperAdmin, roleManager],
        forbiddenRedirect: '/forbidden',
      },
      title: [
        'Экскурсии мир',
        'Типы цен',
      ],
    },
    component: WorldToursPriceTypes,
  },
  {
    path: '/world-tours/price-types/:id',
    name: 'WorldToursPriceTypesForm',
    meta: {
      auth: {
        roles: [roleAdmin, roleSuperAdmin, roleManager],
        forbiddenRedirect: '/forbidden',
      },
      title: [
        'Экскурсии мир',
        'Типы цен',
      ],
    },
    component: WorldToursPriceTypes,
  },
];
